import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n from 'i18next'
import { BomItemAttachmentsController } from 'services/APIs/InternalAPI/AttachmentAPI'
import { AssemblyHeaderDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowException } from 'store/Application/appActions'
import { GetContext } from 'store/storeUtils'
import { UIActions } from 'store/UI/UIActions'
import { newProjectActions } from '../newProjectReducer'
import { bomItemSelector } from '../selectors/bomItemSelector'
import { fetchProject } from './fetchProject'

export const deleteBomItemAttachment = createAsyncThunk<
  any,
  any,
  { state: any }
>(
  'bomItem/deleteFileName',
  async (
    { bomItemId, fileName }: { bomItemId: string; fileName: string[] },
    thunkAPI
  ) => {
    const { partyId, projectId } = GetContext()
    const api = new BomItemAttachmentsController(partyId, projectId)

    thunkAPI.dispatch(
      UIActions.OpenModal('ConfirmationDialog', {
        title: i18n.t('project:delete-attachment', 'Delete Attachment'),
        onConfirm: () => {
          try {
            if (bomItemId === projectId) {
              return updateProjectAttachments(
                thunkAPI,
                fileName,
                api,
                projectId
              )
            }

            return updateBomItemAttachments(thunkAPI, bomItemId, fileName, api)
          } catch (err) {
            ShowException('project', err)
            thunkAPI.dispatch(fetchProject({ projectId: projectId }))
            return thunkAPI.rejectWithValue(err)
          }
        },
      })
    )
  }
)

async function updateBomItemAttachments(
  thunkAPI,
  bomItemId: string,
  fileName: string[],
  api: BomItemAttachmentsController
) {
  const bomItem = bomItemSelector(thunkAPI.getState(), bomItemId)
  if (bomItem.type === 'MaterialHeader' || bomItem.type === 'RoutingHeader') {
    throw new Error(
      'Cannot delete attachment from Material Header or Routing Header'
    )
  }
  thunkAPI.dispatch(
    newProjectActions.setBomItemProperties({
      id: bomItemId,
      attachments: bomItem.attachments?.filter(
        (x) => !fileName.includes(x.fileName)
      ),
    } as Partial<AssemblyHeaderDto>)
  )

  return await api.DeleteFile(bomItemId, fileName)
}

async function updateProjectAttachments(
  thunkAPI,
  fileName: string[],
  api: BomItemAttachmentsController,
  projectId: string
) {
  thunkAPI.dispatch(
    newProjectActions.setActiveProjectProperties({
      attachments: thunkAPI
        .getState()
        .project.activeProject.attachments.filter((x) => {
          return !fileName.includes(x.fileName)
        }),
    })
  )

  return await api.DeleteFile(projectId, fileName)
}
